// extracted by mini-css-extract-plugin
export var label = "_fa-2";
export var slideContainer = "_fa-0";
export var slider = "_fa-1";